import { createSlice } from "@reduxjs/toolkit";

import { Document } from "../types/document";
import { Monitor } from "../types/monitor";

export interface AppointmentPropertyAreaMap {
  id: string;
  propertyId: string;
  label: string;
  url: string;
}

export interface AppointmentPropertyAreaVersion {
  id: string;
  propertyAreaId: string;
  appointmentId: string;
  label: string;
  map?: Document | null; 
  isOriginal: number;
  createdAt: string;
}

export interface AppointmentPropertyArea {
  id: string;
  propertyId: string;
  label: string;
  map?: Document | null;
  version: AppointmentPropertyAreaVersion;
  includes: {
    monitors: Monitor[]; 
  };
}

export type AppointmentPropertyAreasSliceState = {
  appointmentPropertyAreas: AppointmentPropertyArea[];
};

const initialState: AppointmentPropertyAreasSliceState = {
  appointmentPropertyAreas: [],
};

export const appointmentPropertyAreasSlice = createSlice({
  name: "appointmentPropertyAreas",
  initialState,
  reducers: {
    setAppointmentPropertyAreas: (
      state,
      action: { payload: AppointmentPropertyArea[] }
    ) => {
     state.appointmentPropertyAreas = action.payload;
    },
    resetState(state) {
      state.appointmentPropertyAreas = [];
    },
  },
});

export const appointmentPropertyAreasActions =
  appointmentPropertyAreasSlice.actions;
export default appointmentPropertyAreasSlice.reducer;
